import { api } from "./api";

export const apiConstract = {
  getStatistic: () => {
    return api.get("web/contracts/statistic");
  },
  getContracts: (filter, page, size = 10) => {
    return api.post("web/contracts/filter", { filter, page, size });
  },
  getBranch: () => {
    return api.get("web/branches");
  },
};
